import config from './config';

const getServerAddr = () => {
  // eslint-disable-next-line no-constant-condition
  try {
    if (typeof window !== 'undefined' && window.location) {
      const isHttps = location.protocol === 'https:';
      if (isHttps) {
        return config.prodServerAddr;
      } else {
        return config.directServerAddr;
      }
    }
    return '';
  } catch (err) {
    console.error('getServerAddr', err);
    return '';
  }
};

const getLocalServer = () => {
  // eslint-disable-next-line no-constant-condition
  try {
    if (typeof window !== 'undefined' && window.location) {
      return location.origin;
    }
    return '';
  } catch (err) {
    console.error('getLocalServer', err);
    return '';
  }
};

export const host = config.isProd ? getServerAddr() : getLocalServer();

export const URL = {
  upload: host + '/files',
  download: host + '/download_file?filePath={filePath}',
  delete: host + '/delete_file?filePath={filePath}&isFolder={isFolder}&currentFolder={currentFolder}',
  getList: host + '/get_list',
  newFolder: host + '/new_folder',
  renameFolder: host + '/rename_folder',
  gotoFolder: host + '/goto_folder?filePath={filePath}',
};
